<a class="card py-4 px-5" [routerLink]="this.surveyLink">
  <div class="text-container text-center">
    <h2>Welcome to One Medical</h2>
    <p class="mb-4 mb-md-3">
      Share your health history, so that we can personalize your health care experience.
    </p>
    <div class="btn btn-primary">Get Started</div>
  </div>
</a>
